import { Base64 } from "js-base64";

export default {
  methods: {
    /**
     *  解码
     * @param {any} data
     * @returns
     */
    base64Decode(data) {
      const value = Base64.decode(data);
      return JSON.parse(value);
    },
    /**
     *  编码
     * @param {any} data
     * @returns
     */
    base64Encode(data) {
      const result = Base64.encodeURI(JSON.stringify(data));
      return result;
    },
  },
};
